import logo from "./logo.svg";
import "./App.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image1 from "./images/image1.png";
import Image2 from "./images/image2.png";
import Image3 from "./images/image3.png";
import Image4 from "./images/image4.png";
import Image5 from "./images/image5.png";
import Image6 from "./images/image6.png";
import PrizeQImg from "./images/prizeq.png";
import ProgressImg from "./images/progress.png";
import PogPrizeEntryImg from "./images/pogprizeentries.png";
import TwitchIcon from "./images/twitch.png";
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Container className="p-3" style={{ marginTop: "8%" }}>
          <Row className="align-items-center">
            <Col sm={6} style={{ textAlign: "left" }}>
              <p style={{ marginBottom: "0" }}>introducing</p>
              <p style={{ marginTop: "-6%" }}>
                <b>_______________</b>
              </p>
              <p className="title">POGPOINTS</p>
              <p className="subTitle">
                PogPoints gives you new ways to interact with your Twitch
                audience through giveaways using channel points.
              </p>
              <Row>
                <Col>
                  <a target="_blank" href="https://github.com/uyxela/pogpoints/releases/tag/v0.1-alpha">
                    <div
                      className="hoverButton"
                      style={{
                        border: "6px solid white",
                        borderRadius: "10px",
                        padding: "10px",
                      }}
                    >
                      <b>Download</b>
                      <img
                        src={TwitchIcon}
                        style={{
                          width: "35px",
                          float: "right",
                          marginRight: "2%",
                        }}
                      />
                    </div>
                  </a>
                </Col>
                <Col>
                  <a target="_blank" href="https://github.com/uyxela/pogpoints">
                    <div
                      className="hoverButton"
                      style={{
                        border: "6px solid #420789",
                        borderRadius: "10px",
                        padding: "10px",
                        backgroundColor: "#7534C4",
                      }}
                    >
                      <b>View Code</b>
                      <img
                        src={TwitchIcon}
                        style={{
                          width: "35px",
                          float: "right",
                          marginRight: "2%",
                        }}
                      />
                    </div>
                  </a>
                </Col>
              </Row>
            </Col>
            <Col sm={6}>
              <img src={Image1} style={{ width: "70%" }} />
            </Col>
          </Row>
          <Row className="align-items-center" style={{ marginTop: "15%" }}>
            <Col sm={2}>
              <img src={Image4} style={{ width: "120%" }} />
            </Col>
            <Col sm={4} style={{ textAlign: "center" }}>
              <p class="align-middle" className="bodyText">
                Create new and exciting experiences for your stream viewers.
              </p>
            </Col>
            <Col sm={6} style={{ textAlign: "left" }}>
              <img src={Image5} style={{ width: "100%" }} />
            </Col>
          </Row>
          <Row className="align-items-center" style={{ marginTop: "10%" }}>
            <Col sm={6}>
              <img src={Image6} style={{ width: "100%" }} />
            </Col>
            <Col sm={3} style={{ textAlign: "center" }}>
              <p class="align-middle" className="bodyText">
                See all stats at a glance.
              </p>
            </Col>
            <Col sm={3}>
              <img
                src={Image2}
                style={{ width: "120%", transform: "scaleX(-1)" }}
              />
            </Col>
          </Row>
          <Row className="align-items-center" style={{ marginTop: "10%" }}>
            <Col sm style={{ textAlign: "center" }}>
              <p class="align-middle" className="bodyText">
                Custom scenes to add information to your broadcast
              </p>
            </Col>
          </Row>
          <Row className="align-items-center" style={{ marginTop: "2%" }}>
            <Col sm>
              <img src={PrizeQImg} style={{ width: "80%" }} />
            </Col>
            <Col sm>
              <img src={ProgressImg} style={{ width: "80%" }} />
            </Col>
            <Col sm>
              <img src={PogPrizeEntryImg} style={{ width: "80%" }} />
            </Col>
          </Row>
          <Row className="align-items-center" style={{ marginTop: "2%" }}>
            <Col sm>
              <p className="bodyText">Let's get started!</p>
            </Col>
          </Row>
          <Row
            className="align-items-center"
            style={{ marginTop: "2%", marginBottom: "35%" }}
          >
            <Col sm={3} />
            <Col sm style={{ paddingLeft: "8%", paddingRight: "8%" }}>
              <a target="_blank" href="https://github.com/uyxela/pogpoints/releases/tag/v0.1-alpha">
                <div
                  className="hoverButton"
                  style={{
                    border: "6px solid white",
                    borderRadius: "10px",
                    padding: "10px",
                    width: "100%",
                  }}
                >
                  <b>Download and Login</b>
                  <img
                    src={TwitchIcon}
                    style={{
                      width: "35px",
                      float: "right",
                      marginRight: "2%",
                    }}
                  />
                </div>
              </a>
            </Col>
            <Col sm={3} />
          </Row>
        </Container>
      </header>
    </div>
  );
}

export default App;
